// Application lifecycle - MUST mirror backend common/constants.py exactly.
// Dropdowns/filters load the live list from GET /applications/status_options/;
// these constants are only the first-paint fallback and the badge styling map.
//
//  inprogress -> applicant still filling the form (draft)
//  submitted  -> applicant finished; waiting for a reviewer
//  in_review  -> a staff reviewer has picked it up
//  incomplete -> returned to the applicant for corrections
//  verified   -> verification officer confirmed identity/documents (KYC)
//  approved   -> administrator's final decision; membership granted
//  rejected   -> final decline
export const APPLICATION_STATUS = Object.freeze({
  IN_PROGRESS: "inprogress",
  SUBMITTED: "submitted",
  IN_REVIEW: "in_review",
  INCOMPLETE: "incomplete",
  VERIFIED: "verified",
  APPROVED: "approved",
  REJECTED: "rejected",
});

export const STATUS_OPTIONS = Object.freeze([
  { key: APPLICATION_STATUS.IN_PROGRESS, label: "In Progress" },
  { key: APPLICATION_STATUS.SUBMITTED, label: "Submitted" },
  { key: APPLICATION_STATUS.IN_REVIEW, label: "In Review" },
  { key: APPLICATION_STATUS.INCOMPLETE, label: "Incomplete" },
  { key: APPLICATION_STATUS.VERIFIED, label: "Verified" },
  { key: APPLICATION_STATUS.APPROVED, label: "Approved" },
  { key: APPLICATION_STATUS.REJECTED, label: "Rejected" },
]);

export const STATUS_LABELS = Object.freeze(
  STATUS_OPTIONS.reduce((acc, o) => ({ ...acc, [o.key]: o.label }), {}),
);

// Risk category assessment ratings
export const RISK_LEVELS = Object.freeze({
  LOW: "low",
  MEDIUM: "medium",
  HIGH: "high",
});

// Table badge styling (badge-soft-* classes used by the list screens)
export const STATUS_SOFT_BADGE = Object.freeze({
  [APPLICATION_STATUS.IN_PROGRESS]: "badge-soft-secondary",
  [APPLICATION_STATUS.SUBMITTED]: "badge-soft-dark",
  [APPLICATION_STATUS.IN_REVIEW]: "badge-soft-primary",
  [APPLICATION_STATUS.INCOMPLETE]: "badge-soft-warning",
  [APPLICATION_STATUS.VERIFIED]: "badge-soft-info",
  [APPLICATION_STATUS.APPROVED]: "badge-soft-success",
  [APPLICATION_STATUS.REJECTED]: "badge-soft-danger",
});

// Solid badge styling (StatusBadge component)
export const STATUS_BADGE_CLASSES = Object.freeze({
  [APPLICATION_STATUS.IN_PROGRESS]: "badge bg-secondary font-size-12",
  [APPLICATION_STATUS.SUBMITTED]: "badge bg-dark font-size-12",
  [APPLICATION_STATUS.IN_REVIEW]: "badge bg-primary font-size-12",
  [APPLICATION_STATUS.INCOMPLETE]: "badge bg-warning text-dark font-size-12",
  [APPLICATION_STATUS.VERIFIED]: "badge bg-info font-size-12",
  [APPLICATION_STATUS.APPROVED]: "badge bg-success font-size-12",
  [APPLICATION_STATUS.REJECTED]: "badge bg-danger font-size-12",
});
